import type { ComponentType } from 'react';
import EquationBalancer from './EquationBalancer';
import StoichiometryCalc from './StoichiometryCalc';
import MoleConverter from './MoleConverter';
import ReactionTypes from './ReactionTypes';

// REACTIONS / STOICHIOMETRY widget cluster. Each entry maps a slide widget
// `type` to a college-level interactive component. All share the
// { config, onComplete } contract and are resilient to partial/empty config.
export const REACTIONS_WIDGETS: Record<
  string,
  ComponentType<{ config: any; onComplete?: () => void }>
> = {
  equation_balancer: EquationBalancer,
  stoichiometry: StoichiometryCalc,
  mole_converter: MoleConverter,
  reaction_types: ReactionTypes,
};

export { default as EquationBalancer } from './EquationBalancer';
export { default as StoichiometryCalc } from './StoichiometryCalc';
export { default as MoleConverter } from './MoleConverter';
export { default as ReactionTypes } from './ReactionTypes';

export type { EquationBalancerConfig } from './EquationBalancer';
export type { StoichiometryConfig } from './StoichiometryCalc';
export type { MoleConverterConfig } from './MoleConverter';
export type { ReactionTypesConfig } from './ReactionTypes';
